import { render } from "./PageComponent.vue?vue&type=template&id=0012fe7a&scoped=true"
import script from "./PageComponent.vue?vue&type=script&lang=js"
export * from "./PageComponent.vue?vue&type=script&lang=js"

import "./PageComponent.vue?vue&type=style&index=0&id=0012fe7a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0012fe7a"]])

export default __exports__